<div>
  <app-components-togglepanel [(isOpen)]="isOpen" title="Website Audit" toggleBody="true">
    <ng-container *ngIf="reportSummary; else reportNotLoaded">
      <div class="row">
        @if (additionalInformationTemplate) {
          <div class="col-md-5">
            <ng-container *ngTemplateOutlet="organicSearch"></ng-container>
            <ng-container *ngTemplateOutlet="aiReadiness"></ng-container>
            <ng-container *ngTemplateOutlet="mobile"></ng-container>
            <ng-container *ngTemplateOutlet="websiteBuild"></ng-container>
          </div>
          <div class="col-md-7">
            <ng-container *ngTemplateOutlet="additionalInformation"></ng-container>
          </div>
        } @else {
          <div class="col-md-5">
            <ng-container *ngTemplateOutlet="organicSearch"></ng-container>
            <ng-container *ngTemplateOutlet="aiReadiness"></ng-container>
          </div>
          <div class="col-md-5">
            <ng-container *ngTemplateOutlet="mobile"></ng-container>
            <ng-container *ngTemplateOutlet="websiteBuild"></ng-container>
          </div>
        }
      </div>
    </ng-container>
  </app-components-togglepanel>
</div>

<ng-template #reportNotLoaded>
Website Audit is not available
</ng-template>

<ng-template #organicSearch>
  <div class="card">
    <div class="card-header">
      Organic Search
    </div>
    <div class="card-body p-1">
      <ul class="list-group list-group-flush">
        <ng-container *ngTemplateOutlet="reportItem; context: { item: reportSummary.amountOfContent }"></ng-container>
        <ng-container *ngTemplateOutlet="reportItem; context: { item: reportSummary.backlinks}"></ng-container>
      </ul>
    </div>
  </div>
</ng-template>

<ng-template #mobile>
  <div class="card">
    <div class="card-header">
      Mobile
    </div>
    <div class="card-body p-1">
      <ul class="list-group list-group-flush">
        <ng-container *ngTemplateOutlet="reportItem; context: { item: reportSummary.mobile }"></ng-container>
      </ul>
    </div>
  </div>
</ng-template>

<ng-template #websiteBuild>
  <div class="card">
    <div class="card-header">
      Website Build
    </div>
    <div class="card-body p-1">
    <ul class="list-group list-group-flush">
      <ng-container *ngTemplateOutlet="reportItem; context: { item: reportSummary.sslEncryption }"></ng-container>
      <ng-container *ngTemplateOutlet="reportItem; context: { item: reportSummary.sitemap }"></ng-container>
      <ng-container *ngTemplateOutlet="reportItem; context: { item: reportSummary.websiteSize }"></ng-container>
      <ng-container *ngTemplateOutlet="reportItem; context: { item: reportSummary.indexedPages }"></ng-container>
      <ng-container *ngTemplateOutlet="reportItem; context: { item: reportSummary.headings }"></ng-container>
      <ng-container *ngTemplateOutlet="reportItem; context: { item: reportSummary.titlesAndDescriptions }"></ng-container>
      <ng-container *ngTemplateOutlet="reportItem; context: { item: reportSummary.brokenLinks }"></ng-container>
    </ul>
    </div>
  </div>
</ng-template>

<ng-template #aiReadiness>
  <div class="card">
    <div class="card-header">
      AI Readiness
    </div>
    <div class="card-body p-1">
    <ul class="list-group list-group-flush">
      <ng-container *ngTemplateOutlet="reportItem; context: { item: reportSummary.aiUserAgentsAllowed}"></ng-container>
      <!--TODO: Uncomment this once these fields should be enabled <ng-container *ngTemplateOutlet="reportItem; context: { item: reportSummary.localStructuredDataFound}"></ng-container>-->
      <ng-container *ngTemplateOutlet="reportItem; context: { item: reportSummary.faqStructuredDataFound}"></ng-container>
      <ng-container *ngTemplateOutlet="reportItem; context: { item: reportSummary.readingDifficultyOptimized}"></ng-container>
      <ng-container *ngTemplateOutlet="reportItem; context: { item: reportSummary.contentRecentlyUpdated}"></ng-container>
      <!--TODO: Uncomment this once these fields should be enabled <ng-container *ngTemplateOutlet="reportItem; context: { item: reportSummary.llmsTxtFound}"></ng-container>-->
      <ng-container *ngTemplateOutlet="reportItem; context: { item: reportSummary.indexedOnGoogle}"></ng-container>
    </ul>
    </div>
  </div>
</ng-template>

<ng-template #reportItem let-item="item" let-additionalInformation="additionalInformation">
  <li class="list-group-item ps-2">
    <div class="row">
      <div class="col-md-6">
        <span class="fa-stack fa-2xs me-1">
          @switch (item.status) {
          @case (Statuses_Warning) {
          <i class="fa fa-circle fa-stack-2x text-warning"></i>
          <i class="fa fa-exclamation fa-stack-1x fa-inverse"></i>
          }
          @case (Statuses_Pass) {
          <i class="fa fa-circle fa-stack-2x text-success"></i>
          <i class="fa fa-check fa-stack-1x fa-inverse"></i>
          }
          @case (Statuses_Fail) {
          <i class="fa fa-circle fa-stack-2x text-danger"></i>
          <i class="fa fa-xmark fa-stack-1x fa-inverse"></i>
          }
          @case (Statuses_Info) {
          <i class="fa fa-circle fa-stack-2x text-secondary"></i>
          <i class="fa fa-info fa-stack-1x fa-inverse"></i>
          }
          }
        </span>
        <span>{{item.title}}</span>
      </div>
      <div class="col-md-6 d-flex align-items-center">
        <span class="flex-grow-1">{{item.content}}</span>
        @if (item.additionalInformationKey) {
          <div class="d-flex">
            <i class="fa fa-copy text-primary cursor-pointer me-3" title="Copy" (click)="copyAdditionalInformation(item.additionalInformationKey)"></i>
            <i class="fa-solid text-primary ms-auto cursor-pointer"
              [ngClass]="{
                'fa-angle-left': item.additionalInformationKey === additionalInformationTemplate,
                'fa-angle-right': item.additionalInformationKey !== additionalInformationTemplate 
              }"
              (click)="toggleAdditionalInformation(item.additionalInformationKey)"></i>
          </div>
        }
      </div>
    </div>
  </li>
</ng-template>

<ng-template #additionalInformation>
  <div class="card">
    <div class="card-header d-flex align-items-center">
      <span class="flex-grow-1">{{ additionalInformationTemplate }}</span>
      <div class="d-flex">
        <i class="fa fa-copy text-primary cursor-pointer me-3" title="Copy" (click)="copyAdditionalInformation(additionalInformationTemplate)"></i>
        <i class="fa fa-times cursor-pointer" (click)="toggleAdditionalInformation()"></i>
      </div>
    </div>
    <div class="card-body p-1">
      @switch (additionalInformationTemplate) {
        @case ('Broken Links') {
          <ng-container *ngTemplateOutlet="brokenLinks"></ng-container>
        }
      }
    </div>
  </div>
</ng-template>

<ng-template #brokenLinks>
  <ul class="list-group list-group-flush">
    @for(item of reportSummary.brokenLinks.links; track item) {
      <li class="list-group-item ps-2">
        <div class="d-flex w-100 justify-content-between">
          <p class="mb-1"><strong>Page:</strong> <a [href]="item.page" target="_blank">{{ item.page }}</a></p>
          <small class="text-danger">{{ item.statusCode }}</small>
        </div>
        <p class="mb-1"><strong>Content:</strong> {{ item.content }}</p>
        <p class="mb-1"><strong>Link:</strong> <a [href]="item.href" target="_blank">{{ item.href }}</a></p>
      </li>
    }
  </ul>
</ng-template>